import ApiKeysTable from './ApiKeysTable'

export default ApiKeysTable
